import { useMemo } from "react";
import {
  DimensionsFilter,
  useDimensionsQuery,
} from "@/shared/services/api/graphql/generated";
import { omit } from "lodash";

export interface DimensionsFilterType extends DimensionsFilter {
  /**
   * DimensionsFilterType extends DimensionsFilter by adding an optional isLoading property.
   * This allows components to indicate that the dimensions data is still loading,
   * which can be used to conditionally skip the GraphQL query until the necessary filter information is available.
   *
   * The isLoading property is omitted from the actual GraphQL query variables
   */
  isLoading?: boolean;
}

export const useDimensions = (filter?: DimensionsFilterType) => {
  const { data, loading } = useDimensionsQuery({
    variables: { filter: omit(filter, "isLoading") as DimensionsFilter },
    skip: !filter || filter.isLoading,
    fetchPolicy: "cache-and-network",
  });

  const dimensions = useMemo(() => {
    const dimensions = data?.dimensions || [];
    if (filter?.type) {
      return dimensions.filter((dim) => filter.type?.includes(dim?.type));
    }
    return dimensions;
  }, [data]);

  return { dimensions, loading };
};
